import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import containerStyles from './Container.styles.esm.js';

const Container = (_a) => {
    var { className, asChild = false, display, align, maxWidth } = _a, props = __rest(_a, ["className", "asChild", "display", "align", "maxWidth"]);
    const classes = containerStyles({
        display: display,
        align: align,
        maxWidth: maxWidth,
        class: className,
    });
    const Comp = asChild ? Slot : "div";
    return jsx(Comp, Object.assign({ className: classes }, props));
};
Container.displayName = "Container";

export { Container };
